import { render, staticRenderFns } from "./CabinetTemplate.vue?vue&type=template&id=4f554166&scoped=true"
import script from "./CabinetTemplate.vue?vue&type=script&lang=ts"
export * from "./CabinetTemplate.vue?vue&type=script&lang=ts"
import style0 from "./CabinetTemplate.vue?vue&type=style&index=0&id=4f554166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f554166",
  null
  
)

export default component.exports